export function logFn(name, ...args) {
  console.groupCollapsed(`[@gandi/tracking]: ${name}`);
  console.log(...args);
  console.groupEnd();
}